import {MutableRefObject, useRef} from "react";

// Types ----

export type SubmitAction = 'save' | 'saveAndClose';

// Hook ----

export function useSubmitActionRef(): MutableRefObject<SubmitAction> {
  return useRef<SubmitAction>('saveAndClose');
}